/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdfResponse
 */
export interface PdfResponse {
    /**
     * 
     * @type {string}
     * @memberof PdfResponse
     */
    base64EncodedPdf: string;
}

/**
 * Check if a given object implements the PdfResponse interface.
 */
export function instanceOfPdfResponse(value: object): value is PdfResponse {
    if (!('base64EncodedPdf' in value) || value['base64EncodedPdf'] === undefined) return false;
    return true;
}

export function PdfResponseFromJSON(json: any): PdfResponse {
    return PdfResponseFromJSONTyped(json, false);
}

export function PdfResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'base64EncodedPdf': json['base64EncodedPdf'],
    };
}

  export function PdfResponseToJSON(json: any): PdfResponse {
      return PdfResponseToJSONTyped(json, false);
  }

  export function PdfResponseToJSONTyped(value?: PdfResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base64EncodedPdf': value['base64EncodedPdf'],
    };
}

